import { useRef, useState, useEffect } from 'react';
import { ReactComponent as OpenIcon } from '../../../img/open-measure.svg';
import { ReactComponent as SortIcon } from '../../../img/sortingIcon.svg';

import './sort.scss';

const posts = [
    // { id: 1, title: 'Type', content: ['FFP behavior', 'SFP behavior'] },
    // { id: 2, title: 'Range', content: ['Close range', 'Mid-long range', 'Standard'] },
    // { id: 3, title: 'Measurements', content: ['Ballistic', 'Non-ballistic', 'With angular measurements'] },
    // { id: 4, title: 'Rangefinder', content: ['With stadiametric rangefinder', 'Without rangefinding capability'] },
    // { id: 5, title: 'Sort by', content: ['Upload date', 'Download count'] }
];


const Filters = ({ handlerSetSort, activeSort }) => {
    const [isSortOpen, setIsSortOpen] = useState(false);
    const [sortOpenName, setSortOpenName] = useState('');

    const typeBtn = useRef(null);
    const rangeBtn = useRef(null);
    const measurementsBtn = useRef(null);
    const rangefinderBtn = useRef(null);
    const sortByBtn = useRef(null);

    const typeIconRef = useRef(null);
    const rangeIconRef = useRef(null);
    const measurementsIconRef = useRef(null);
    const rangefinderIconRef = useRef(null);
    const sortByIconRef1 = useRef(null);
    const sortByIconRef2 = useRef(null);

    const typeContent = useRef(null);
    const rangeContent = useRef(null);
    const measurementsContent = useRef(null);
    const rangefinderContent = useRef(null);
    const sortByContent = useRef(null);

    useEffect(() => {

        if (!isSortOpen) return;

        const handleClick = e => {

            if (!typeContent.current) return;

            if (typeContent.current && !typeContent.current.contains(e.target)) { setIsSortOpen(false); setSortOpenName('') }
        };


        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };

    }, [isSortOpen, setIsSortOpen, typeContent]);

    useEffect(() => {

        if (!isSortOpen) return;

        const handleClick = e => {
            if (!rangeContent.current) return;

            if (rangeContent.current && !rangeContent.current.contains(e.target)) {
                setIsSortOpen(false); setSortOpenName('')
            }
        };


        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };

    }, [isSortOpen, setIsSortOpen, rangeContent]);

    useEffect(() => {

        if (!isSortOpen) return;

        const handleClick = e => {

            if (!measurementsContent.current) return;

            if (measurementsContent.current && !measurementsContent.current.contains(e.target)) { setIsSortOpen(false); setSortOpenName('') }
        };


        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };

    }, [isSortOpen, setIsSortOpen, measurementsContent, rangefinderContent, sortByContent]);

    useEffect(() => {

        if (!isSortOpen) return;

        const handleClick = e => {

            if (!rangefinderContent.current) return;

            if (rangefinderContent.current && !rangefinderContent.current.contains(e.target)) { setIsSortOpen(false); setSortOpenName('') }

        };


        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };

    }, [isSortOpen, setIsSortOpen, rangefinderContent, sortByContent]);

    useEffect(() => {

        if (!isSortOpen) return;

        const handleClick = e => {

            if (!sortByContent.current) return;

            if (sortByContent.current && !sortByContent.current.contains(e.target)) { setIsSortOpen(false); setSortOpenName('') }
        };


        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };

    }, [isSortOpen, setIsSortOpen, sortByContent]);


    useEffect(() => {
        const handleClick = e => {
            if (e.target === typeBtn.current
                || e.target === rangeBtn.current
                || e.target === measurementsBtn.current
                || e.target === rangefinderBtn.current
                || e.target === sortByBtn.current

                || typeIconRef.current.contains(e.target)
                || rangeIconRef.current.contains(e.target)
                || measurementsIconRef.current.contains(e.target)
                || rangefinderIconRef.current.contains(e.target)
                || sortByIconRef1.current.contains(e.target)
                || sortByIconRef2.current.contains(e.target)
            ) { setIsSortOpen(!isSortOpen) }
        }

        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);


    return (
        <div className="sort__block">
            <div className="sort__block-types">
                <div className="sort__content" key={'Type'}>
                    <button ref={typeBtn} className={'sort__button-title'} onClick={() => { setSortOpenName('Type') }}>Type<OpenIcon ref={typeIconRef} style={{ marginLeft: 10 }} /> </button>

                    {sortOpenName === 'Type' && isSortOpen ? (
                        <div ref={typeContent} className={'sort__button-content'}>
                            <button key={'FFP behavior'} className={`sort__button ${activeSort === 'FFP behavior' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Type', activeSort === 'FFP behavior' ? '' : e.target.textContent) }}>{'FFP behavior'}</button>
                            <button key={'SFP behavior'} className={`sort__button ${activeSort === 'SFP behavior' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Type', activeSort === 'SFP behavior' ? '' : e.target.textContent) }}>{'SFP behavior'}</button>
                        </div>
                    ) : null}
                </div>

                <div className="sort__content" key={'Range'}>
                    <button ref={rangeBtn} className={'sort__button-title'} onClick={() => { setSortOpenName('Range') }}>Range<OpenIcon ref={rangeIconRef} style={{ marginLeft: 10 }} /> </button>

                    {sortOpenName === 'Range' && isSortOpen ? (
                        <div ref={rangeContent} className={'sort__button-content'}>
                            <button key={'Close range'} className={`sort__button ${activeSort === 'Close range' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Range', activeSort === 'Close range' ? '' : e.target.textContent) }}>{'Close range'}</button>
                            <button key={'Mid-long range'} className={`sort__button ${activeSort === 'Mid-long range' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Range', activeSort === 'Mid-long range' ? '' : e.target.textContent) }}>{'Mid-long range'}</button>
                            <button key={'Standard'} className={`sort__button ${activeSort === 'Standard' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Range', activeSort === 'Standard' ? '' : e.target.textContent) }}>{'Standard'}</button>
                        </div>
                    ) : null}
                </div>

                <div className="sort__content" key={'Measurements'}>
                    <button ref={measurementsBtn} className={'sort__button-title'} onClick={() => { setSortOpenName('Measurements') }}>Measurements<OpenIcon ref={measurementsIconRef} style={{ marginLeft: 10 }} /> </button>

                    {sortOpenName === 'Measurements' && isSortOpen ? (
                        <div ref={measurementsContent} className={'sort__button-content'}>
                            <button key={'Ballistic'} className={`sort__button ${activeSort === 'Ballistic' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Measurements', activeSort === 'Ballistic' ? '' : e.target.textContent) }}>{'Ballistic'}</button>
                            <button key={'Non-ballistic'} className={`sort__button ${activeSort === 'Non-ballistic' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Measurements', activeSort === 'Non-ballistic' ? '' : e.target.textContent) }}>{'Non-ballistic'}</button>
                            <button key={'With angular measurements'} className={`sort__button ${activeSort === 'With angular measurements' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Measurements', activeSort === 'With angular measurements' ? '' : e.target.textContent) }}>{'With angular measurements'}</button>
                        </div>
                    ) : null}
                </div>

                <div className="sort__content" key={'Rangefinder'}>
                    <button ref={rangefinderBtn} className={'sort__button-title'} onClick={() => { setSortOpenName('Rangefinder') }}>Rangefinder<OpenIcon ref={rangefinderIconRef} style={{ marginLeft: 10 }} /> </button>

                    {sortOpenName === 'Rangefinder' && isSortOpen ? (
                        <div ref={rangefinderContent} className={'sort__button-content'}>
                            <button key={'With stadiametric rangefinder'} className={`sort__button ${activeSort === 'With stadiametric rangefinder' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Rangefinder', activeSort === 'With stadiametric rangefinder' ? '' : e.target.textContent) }}>{'With stadiametric rangefinder'}</button>
                            <button key={'Without rangefinding capability'} className={`sort__button ${activeSort === 'Without rangefinding capability' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Rangefinder', activeSort === 'Without rangefinding capability' ? '' : e.target.textContent) }}>{'Without rangefinding capability'}</button>
                        </div>
                    ) : null}
                </div>

            </div>

            <div className="sort__content" key={'Sort by'}>
                <button ref={sortByBtn} className={'sort__button-title'} onClick={() => { setSortOpenName('Sort by') }}><SortIcon ref={sortByIconRef1} style={{ marginRight: 10 }} />Sort by<OpenIcon ref={sortByIconRef2} style={{ marginLeft: 10 }} /> </button>

                {sortOpenName === 'Sort by' && isSortOpen ? (
                    <div ref={sortByContent} className={'sort__button-content'}>
                        <button key={'Upload date'} className={`sort__button ${activeSort === 'Upload date' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Sort by', activeSort === 'Upload date' ? '' : e.target.textContent) }}>{'Upload date'}</button>
                        <button key={'Download count'} className={`sort__button ${activeSort === 'Download count' ? 'sort__button-active' : ''}`} onClick={(e) => { handlerSetSort('Sort by', activeSort === 'Download count' ? '' : e.target.textContent) }}>{'Download count'}</button>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default Filters;
